/*
  pm-offer-attr — resume de « comment c'est achete » sur la commande (2026-10-05, Imran).
  Chaque ligne ajoutee par un bouton marque porte une propriete cachee `_pm_offer` :
    « Buy 1 from Product Page »    -> palier « Buy 1 » du selecteur de la fiche produit   (avant : « Buy 1 product », « Buy 1 »)
    « Buy 3 from Choose Card »     -> palier « Choose Any 3 Designs » du selecteur          (avant : « Choose Any 3 Designs »)
    « Buy 1 from Collection Page » -> bouton « + Add to cart » d'une tuile de collection     (avant : « Buy 1 Collection »)
    « Buy 1 from Most Loved »      -> bouton du bloc des 6 preferes en haut des collections (avant : « Buy 1 Most Loved »)
  Libelles renommes le 2026-10-06 (Imran).
  Ce script recalcule l'attribut de panier « Offer (product page) » a partir des lignes, sur TOUTES les
  pages (avant, seule la fiche produit le faisait), ex. « Choose Any 3 Designs x1 + Buy 1 Collection x2 ».
  Shopify le recopie sur la commande (rubrique Additional details). Meme logique pour « Add-ons (product page) ».
*/
(function () {
  var OFFER_ATTR = 'Offer (product page)';
  var ADDON_ATTR = 'Add-ons (product page)';
  var LOT3 = 'Buy 3 from Choose Card';
  // 2026-10-06 (Imran) : nouveaux libelles. Les paniers ouverts avant le changement portent encore les anciens :
  // on les traduit ici pour que le resume parle toujours la meme langue. Les COMMANDES deja passees gardent
  // leur ancien libelle (historique) — correspondance dans AGENTS.md.
  var OFFER_RENAME = { 'Buy 1': 'Buy 1 from Product Page', 'Buy 1 product': 'Buy 1 from Product Page',
    'Choose Any 3 Designs': 'Buy 3 from Choose Card', 'Buy 1 Collection': 'Buy 1 from Collection Page',
    'Buy 1 Most Loved': 'Buy 1 from Most Loved' };
  function offerSummary(cart) {
    var q = {}, order = [];
    (cart.items || []).forEach(function (it) {
      var v = it.properties && it.properties._pm_offer;
      if (!v) return;
      v = OFFER_RENAME[v] || v;
      if (!(v in q)) { q[v] = 0; order.push(v); }
      q[v] += it.quantity;
    });
    var parts = [];
    order.forEach(function (v) {
      if (v === LOT3) { var lots = Math.floor(q[v] / 3); if (lots) parts.push(v + ' x' + lots); }
      else parts.push(v + ' x' + q[v]);
    });
    return parts.join(' + ');
  }
  function addonSummary(cart) {
    var q = {}, order = [];
    (cart.items || []).forEach(function (it) {
      var v = it.properties && it.properties._pm_addon;
      if (!v) return;
      if (!(v in q)) { q[v] = 0; order.push(v); }
      q[v] += it.quantity;
    });
    return order.map(function (v) { return v + ' x' + q[v]; }).join(', ');
  }
  var busy = false;
  // 2026-10-09 : une autre app ecrit elle aussi dans le panier (attribut `__ref_id`) au meme moment,
  // a chaque rechargement du tiroir. Deux ecritures simultanees : la derniere peut effacer l'autre,
  // et notre attribut etait parfois perdu (mesure : 1 ajout sur 2). Apres chaque ecriture on
  // relit donc le panier 1,5 s plus tard et on reecrit une fois si l'attribut manque.
  function sync(isRetry) {
    if (busy) return Promise.resolve(); busy = true;
    var wrote = false;
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (cart) {
        window.pmLastCart = cart; // 2026-10-09 : dernier panier connu, lu par pm-bundle-picker.js (livre deja present ?)
        var want = offerSummary(cart), have = (cart.attributes && cart.attributes[OFFER_ATTR]) || '';
        var wantAdd = addonSummary(cart), haveAdd = (cart.attributes && cart.attributes[ADDON_ATTR]) || '';
        if (want === have && wantAdd === haveAdd) return;
        wrote = true;
        var a = {}; a[OFFER_ATTR] = want; a[ADDON_ATTR] = wantAdd; // vide = Shopify retire l'attribut
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) });
      }).catch(function () {}).then(function () {
        busy = false;
        if (wrote && !isRetry) setTimeout(function () { sync(true); }, 1500);
      });
  }
  window.pmSyncOfferAttr = sync;
  function bind() {
    if (window.jQuery) jQuery('body').on('ajaxCart.afterCartLoad', function () { sync(false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
